export default __webpack_public_path__ + "Asset_Content_EMU.b728e39063cc5cb24238ca49bbe8a363.jpg";